// removed by extract-text-webpack-plugin
module.exports = {"container":"Gv93IXi915i-zvWFTQ0vj","input":"ZlMLBXEQ_AKCJH6p0tkl7","label":"_2Mqr3b8_yEgxfWjYVLUx4-","button":"T3zDnTeBwmMZN5U5_AFcq","icon":"_29FekJc4CBG3rYFVWbntS2","title":"vzpUp8DynwxoXbyazqOP6"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Custom/Add/AddProducts/styles.css
// module id = 3189
// module chunks = 0